import { render, staticRenderFns } from "./sideregister.vue?vue&type=template&id=15be604a&scoped=true&"
import script from "./sideregister.vue?vue&type=script&lang=js&"
export * from "./sideregister.vue?vue&type=script&lang=js&"
import style0 from "./sideregister.vue?vue&type=style&index=0&id=15be604a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be604a",
  null
  
)

export default component.exports